<template>
 <div class="app">
    <div class="bar">
        <div class="inputWrap">
            <div style="margin: 0px 10px;line-height: 30px;color:#666">
              请输入WKT格式数据,GEOJSON数据或者坐标(坐标格式: A B,A B或A,B;A,B)
            </div>
            <div>
              <el-switch v-model="wayPointSitch" style="margin:5px 10px 0px 10px" active-text="途径点" @change="waypointChange"></el-switch>
            </div>
            <div style="color:#f00;height:30px;margin-left: 10px;" >{{toastMsg}}</div>
            <div>
              <el-input v-model="inputResult" id="inputResult" type="textarea" style="width:440px;"  :rows="15"  size="medium"></el-input>
              <el-button type="primary" size="medium" @click="parseInput" style="margin:20px 20px 20px 0px;width:100px;cursor: pointer;">上图</el-button>
            </div>
        </div>
    </div>
    <div class="mapWrap" >
      <div  ref="map" style="width:100%;height:100%"></div>
    </div>
    <div id="option-panel" style="z-index:1111;cursor: pointer;">
      <div class="city-selector" v-click-out="closeCityPanel">
            <a class="city-name" @click="toggleCityPanel">{{currentCity}}<span style="padding-left:2px;color: #409eff;">[更换城市]</span></a>
            <div class="city-panel-box">
                <citypanel v-show="showCityPanel" @selected="changeCity"></citypanel>
            </div>
        </div>
    </div>
 </div>
</template>
<script>
import citypanel from "./components/citypanel.vue";
import clickOut from './components/outside.js';
import axios from 'axios';
import utils from "./assets/js/utils.js";

let globalMap;
let markerPoi;
let polyline;
let ieOverlayGroup;

function getCenterMap (maxLonlat, minLonlat) {
  let maxLng, maxLat, minLng, minLat, pointArr;
  if (arguments.length == 2)
  {
    maxLonlat = maxLonlat.split(',');
    minLonlat = minLonlat.split(',');
    maxLng = maxLonlat[0], maxLat = maxLonlat[1], minLng = minLonlat[0], minLat = minLonlat[1];
  }
  if (arguments.length == 1)
  {
    pointArr = [...maxLonlat];
    maxLonlat = pointArr[0];
    minLonlat = pointArr[0];
    maxLng = maxLonlat[0], maxLat = maxLonlat[1], minLng = minLonlat[0], minLat = minLonlat[1];
    pointArr.forEach(item => {
      let arr = item;
      if (Number(arr[0]) > Number(maxLng)) maxLng = arr[0];
      if (Number(arr[0]) < Number(minLng)) minLng = arr[0];
      if (Number(arr[1]) > Number(maxLat)) maxLat = arr[1];
      if (Number(arr[1]) < Number(minLat)) minLat = arr[1];
    })
  }

  var cenLng = (parseFloat(maxLng) + parseFloat(minLng)) / 2;
  var cenLat = (parseFloat(maxLat) + parseFloat(minLat)) / 2;
  return {
    center: [cenLng, cenLat],
    maxLonlat: maxLng + ',' + maxLat,
    minLonlat: minLng + ',' + minLat
  };
}

function setFitView (path) {
    path = path.split(';');
    let lonlats = [];
    path.forEach(v => {
      if (!v) {return}
      v = v.split(',');
      lonlats.push([parseFloat(v[0]), parseFloat(v[1])]);
    });
    let parsePath = getCenterMap(lonlats);
    globalMap.fitBounds([parsePath.maxLonlat.split(',').map(v => { return parseFloat(v) }), parsePath.minLonlat.split(',').map(v => { return parseFloat(v) })], {
      padding: { top: 150, bottom: 100, left: 100, right: 200 }
    });
};

function judgeIE(){
    var ua = navigator.userAgent.toLocaleLowerCase();
    if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
        return true;
    }
    return false;
}

function getPolygon(polygonstr){
  polygonstr = polygonstr.replace(/\)\)\,\(\(/g,';');
  polygonstr = polygonstr.replace(/\)\,\(/g,';');
  polygonstr = polygonstr.replace(/\(/g,'');
  polygonstr = polygonstr.replace(/\)/g,'');
  console.log(polygonstr)
  return polygonstr;
}

export default {
  directives: { clickOut },
  data(){
    return {
        radio: '1',
        toastResult:false,
        inputResult:'',
        toastMsg:"",
        list:[],
        currentCity: '北京市',
        wayPointSitch:false,
        showCityPanel:false,
        styleHeight:{height:'500px'}
    } 
  },
  components:{citypanel},
  mounted() {
    nimap.accessToken="您的AK"
    //nimap.accessToken='n3ZB155x1i79QUDyuz57oi9tOuT79G97'
    let lbsnum = utils.ac(8);
    let lbstm = parseInt(new Date().getTime()/1000);
    let str = 'lbsdevchecknum' + window.navigator.userAgent + lbstm;
    let md5str = utils.hex_md5(str);
    let sendUrl = 'lbssign='+md5str +'&lbsnum='+ lbsnum+'&lbstm='+lbstm;
    globalMap = new nimap.Map({
        container: this.$refs.map,
        style: 'https://lbs.navinfo.com/develop-map-ak/style/normal?'+sendUrl,
        //style:'https://lbs.navinfo.com/open-map-ak/style/normal',
        zoom:11, //初始化地图层级
        center: [116.397428, 39.90923], //初始化地图中心点
        localIdeographFontFamily: "PingFang SC,Microsoft YaHei,微软雅黑,Arial,sans-serif,黑体" //字体本地读取
    });

     globalMap.on('moveend', ()=>{
        let zoom  = globalMap.getZoom();
        let center = globalMap.getCenter();
        center =  `${center.lng},${center.lat}`;
        //&ak=Ian3b11M3799Y53179q9zP39vn7l797j;
        let lbsnum = utils.ac(8);
        let lbstm = parseInt(new Date().getTime()/1000);
        let str = 'lbsdevchecknum' + window.navigator.userAgent + lbstm;
        let md5str = utils.hex_md5(str);
        let sendUrl = '&lbssign='+md5str +'&lbsnum='+ lbsnum+'&lbstm='+lbstm;
        axios.get(`https://lbs.navinfo.com/develop-api/geocoder/v1/regeo?lonlats=${center}` + sendUrl).then(res=>{
            if(res.status == 200 && res.data.status == 200){
                let ad = res.data.data[0]['ad'] || '';
                if(ad != ''){
                    if(zoom >=11){
                        this.currentCity = ad.city
                    }else if(zoom >= 9){
                        if(ad.prov == '直辖市'){
                            this.currentCity = ad.city
                        }else{
                            this.currentCity = ad.prov
                        }
                    }else{
                        this.currentCity = "全国"
                    }
                }
            }
        })
    });

    
  },
  methods:{
      toggleCityPanel () {
          this.showCityPanel = !this.showCityPanel;
      },
      
      changeCity (city) {
          this.showCityPanel = false;
          if(city.city.indexOf('州') != -1 || city.city.indexOf('区') != -1 || city.city.indexOf('盟') != -1 || city.city.indexOf('台湾') != -1 || city.city.indexOf('香港') != -1|| city.city.indexOf('澳门') != -1  ){
            this.currentCity = city.city;
          }else{
            this.currentCity = city.city+'市';
          }
          
          let lnglat = city.lonlat.split(',').map(v=>{return parseFloat(v)});
          globalMap.flyTo({center: lnglat})
      },
      closeCityPanel () {
          this.showCityPanel = false;
      },
      toastMsgFunc(val){
        this.toastMsg = val;
        setTimeout(()=>{
          this.toastMsg = '';
        },10000)
      },
      waypointChange(){
        if(!this.inputResult.trim()){
          return;
        }else{
          this.parseInput();
        }
      },
      parseInput(){
        this.toastMsg = '';
        if(markerPoi != null){
          markerPoi.remove();
        }
        if(polyline){
          globalMap.removeLayer(polyline);
          polyline = null;
        }
        
        
        if(judgeIE()){
          if(ieOverlayGroup){
            ieOverlayGroup.clearOverlays();
            ieOverlayGroup = null;
          }
        }else{
          let arr = ['geojson_line','geojson_point','geojson_polygon'];
          arr.forEach(v=>{
            if(globalMap.getLayer(v)){
              globalMap.removeLayer(v)
            }
          })
          if(globalMap.getSource('geojsondata')){
            globalMap.removeSource('geojsondata')
          }
        }
        if(!this.inputResult){
          this.toastMsgFunc('请输入坐标或GEOJSON');
          return;
        }
        let stringType = '';
        let coordsError = true;
        if((this.inputResult.trim().toUpperCase().indexOf('POINT') != -1 || this.inputResult.trim().toUpperCase().indexOf('LINESTRING') != -1 || this.inputResult.trim().toUpperCase().indexOf('POLYGON') != -1) && this.inputResult.trim().toLowerCase().indexOf('feature') == -1){
          stringType = 'mkt';
          coordsError = false;
        }
        if(this.inputResult.trim().toLowerCase().indexOf('feature') != -1){
          stringType = 'geojson';
          coordsError = false;
        }else if(/^[+-]?\d{1,3}(\.\d+)?\,\s*[+-]?\d{1,2}(\.\d+)?$/.test(this.inputResult.trim())){
          stringType = 'A,B';
          coordsError = false;
        }else if(/^[+-]?\d{1,3}(\.\d+)?\ \s*[+-]?\d{1,2}(\.\d+)?$/.test(this.inputResult.trim())){
          stringType = 'A B';
          coordsError = false;
        }
        if(this.inputResult.trim().indexOf(';') != -1 && this.inputResult.trim().indexOf(',') != -1  && coordsError){
          coordsError = false
          stringType = 'A,B;A,B'
          this.inputResult.trim().split(';').filter(v=>v).forEach(v=>{
            if(!/^[+-]?\d{1,3}(\.\d+)?\,\s*[+-]?\d{1,2}(\.\d+)?$/.test(v)){
              coordsError = true;
            }
          });
          if(coordsError){
            return this.toastMsgFunc('坐标格式A,B;A,B数据有误,请检查!');
          }
        }
        if(this.inputResult.trim().indexOf(';') == -1 && this.inputResult.trim().indexOf(',') != -1 && this.inputResult.trim().indexOf(' ') != -1  && coordsError){
          coordsError = false;
          stringType = 'A B,A B';
          this.inputResult.trim().split(',').filter(v=>v).forEach(v=>{
            if(!/^[+-]?\d{1,3}(\.\d+)?\ \s*[+-]?\d{1,2}(\.\d+)?$/.test(v)){
              coordsError = true;
            }
          })
          if(coordsError){
            return this.toastMsgFunc('坐标格式A B,A B数据有误,请检查!');
          }
        }
        if(coordsError){
          return this.toastMsgFunc('请输入正确格式的数据!');
        }

        let bounds = [];
        let geojson = {
            type: "FeatureCollection",
            features:[],
        }
        if(stringType == 'A,B' || stringType == 'A B'){
          let lnglat = '';
          if(stringType == 'A,B'){
            lnglat = this.inputResult.trim().split(',').map(v=>{return parseFloat(v)});
          }else if(stringType == 'A B'){
            lnglat = this.inputResult.trim().split(' ').map(v=>{return parseFloat(v)});
          }
          let span = document.createElement('span');
          span.className = 'nimap-marker mark-onway'
          markerPoi = new nimap.Marker({element:span,offset:[0, -12]});
          markerPoi.setLngLat(lnglat);
          markerPoi.addTo(globalMap);
          globalMap.flyTo({center: lnglat})
        }
        if(stringType == 'A B,A B' || stringType == 'A,B;A,B'){
            let path = [];
            if(stringType == 'A B,A B'){
              path = this.inputResult.trim().split(',').filter(v=>v).map((v,i)=>{return v.split(' ').map(m=>{return parseFloat(m)})});
            }else if(stringType == 'A,B;A,B'){
              path = this.inputResult.trim().split(';').filter(v=>v).map(v=>{return v.split(',').map(m=>{return parseFloat(m)})});
            }
            if(path.length >= 3 && this.wayPointSitch){
              //途径点的坐标
              path.forEach((m,n)=>{
                if(n>0 && n<path.length-1){
                  geojson.features.push({
                      "type": "Feature", 
                      "properties": { 
                        "id":"wayPoint_"+n,
                        "color":'#409EFF',
                        "radius":8,
                      }, 
                      "geometry": { 
                        "type": "Point", 
                        "coordinates": m 
                      }
                  })
                }
              })
            }
            polyline = new nimap.Polyline({
                path: path,
                "line-join": 'round',
                "line-cap": 'round',
                "line-width":8,
                'line-blur':0,
                "line-color":'#00bd01'
            });
            polyline.addTo(globalMap);
            globalMap.setFitView(polyline.path)
        }
        //wkt点线面
        if(stringType == 'mkt' && this.inputResult.trim().toUpperCase().indexOf('POINT') != -1 && this.inputResult.trim().toLowerCase().indexOf('feature') == -1 && this.inputResult.trim().toUpperCase().indexOf('MULTIPOINT(') == -1 ){
          let lnglat = this.inputResult.trim().toUpperCase().substring(this.inputResult.trim().toUpperCase().indexOf('(')+1,this.inputResult.trim().toUpperCase().indexOf(')'));
          if(!/^[+-]?\d{1,3}(\.\d+)?\ \s*[+-]?\d{1,2}(\.\d+)?$/.test(lnglat)){
              return this.toastMsgFunc('WKT POINT格式有误!');
          }
          lnglat = lnglat.split(' ').map(v=>{return parseFloat(v)});
          let span = document.createElement('span');
          span.className = 'nimap-marker mark-onway'
          markerPoi = new nimap.Marker({element:span,offset:[0, -12]});
          markerPoi.setLngLat(lnglat);
          markerPoi.addTo(globalMap);
          globalMap.flyTo({center: lnglat})
        }
        if(stringType == 'mkt' && this.inputResult.trim().toUpperCase().indexOf('LINESTRING') != -1  && this.inputResult.trim().toLowerCase().indexOf('feature') == -1 && this.inputResult.trim().toUpperCase().indexOf('MULTILINESTRING(') == -1){
          let lnglats = this.inputResult.trim().toUpperCase().substring(this.inputResult.trim().toUpperCase().indexOf('(')+1,this.inputResult.trim().toUpperCase().indexOf(')'));
          coordsError = false
          lnglats.trim().split(',').filter(v=>v).forEach(v=>{
            if(!/^[+-]?\d{1,3}(\.\d+)?\ \s*[+-]?\d{1,2}(\.\d+)?$/.test(v)){
              coordsError = true;
            }
          });
          
          if(coordsError){
            return this.toastMsgFunc('WKT LINESTRING格式有误!');
          }
          lnglats = lnglats.split(',').map(v=>{return v.split(' ').map(m=>{return parseFloat(m)})});
          if(lnglats.length >= 3 && this.wayPointSitch){
              //途径点的坐标
              lnglats.forEach((m,n)=>{
                if(n>0 && n<lnglats.length-1){
                  geojson.features.push({
                      "type": "Feature", 
                      "properties": { 
                        "id":"wayPoint_"+n,
                        "color":'#409EFF',
                        "radius":8,
                      }, 
                      "geometry": { 
                        "type": "Point", 
                        "coordinates": m 
                      }
                  })
                }
              })
          }
          polyline = new nimap.Polyline({
                path: lnglats,
                "line-join": 'round',
                "line-cap": 'round',
                "line-width":8,
                'line-blur':0,
                "line-color":'#00bd01'
            });
            polyline.addTo(globalMap);
            globalMap.setFitView(polyline.path)
        }
        if(stringType == 'mkt' && this.inputResult.trim().toUpperCase().indexOf('POLYGON') != -1  && this.inputResult.trim().toLowerCase().indexOf('feature') == -1 && this.inputResult.trim().toUpperCase().indexOf('MULTIPOLYGON(') == -1){
            let lnglats = this.inputResult.trim().toUpperCase().substring(this.inputResult.trim().toUpperCase().indexOf('(')+2,this.inputResult.trim().toUpperCase().lastIndexOf(')')-1);
            lnglats = lnglats.replace(/\)\,\(/g,';');
            coordsError = false
            lnglats.split(';').forEach((v,i)=>{
              v.split(',').forEach(m=>{
                if(!/^[+-]?\d{1,3}(\.\d+)?\ \s*[+-]?\d{1,2}(\.\d+)?$/.test(m)){
                  coordsError = true;
                }
              })
              if(!coordsError){
                let coordinates = v.split(',').map(m=>{return m.split(' ').map(q=>{return parseFloat(q)})})
                coordinates.forEach(m=>{
                  bounds.push(m);
                })
                if(coordinates.length >= 3 && this.wayPointSitch){
                      //途径点的坐标
                      coordinates.forEach((m,n)=>{
                      if(n>=0 && n<coordinates.length-1){
                        geojson.features.push({
                            "type": "Feature", 
                            "properties": { 
                              "id":"wayPoint_"+n,
                              "color":'#409EFF',
                              "radius":8,
                            }, 
                            "geometry": { 
                              "type": "Point", 
                              "coordinates": m 
                            }
                        })
                      }
                    })
                }
                geojson.features.push({
                    "type": "Feature", 
                    "properties": { 
                      "id":"Polygon_"+i,
                      "color": '#00bd01',
                      "opacity": 0.2
                    }, 
                    "geometry": { 
                      "type": "Polygon", 
                      "coordinates": [coordinates]
                    } 
                  })
              }
            });
            if(coordsError){
              return this.toastMsgFunc('WKT POLYGON格式有误!');
            }
            
        }
        //wkt多点线面
        if(stringType == 'mkt' && this.inputResult.trim().toUpperCase().indexOf('MULTIPOINT') != -1 && this.inputResult.trim().toLowerCase().indexOf('feature') == -1){
            let lnglatstrpoints = this.inputResult.trim().toUpperCase();
            lnglatstrpoints  = lnglatstrpoints.substring(lnglatstrpoints.indexOf('(')+1,lnglatstrpoints.lastIndexOf(')'));
            coordsError = false;
            lnglatstrpoints = lnglatstrpoints.replace(/\)/g,'');
            lnglatstrpoints = lnglatstrpoints.replace(/\(/g,'');
            lnglatstrpoints.split(',').forEach((v,i)=>{
              if(!/^[+-]?\d{1,3}(\.\d+)?\ \s*[+-]?\d{1,2}(\.\d+)?$/.test(v)){
                coordsError = true;
              }
              if(!coordsError){
                let coordinates = v.split(' ').map(m=>{return parseFloat(v)});
                bounds.push(coordinates);
                geojson.features.push({
                  "type": "Feature", 
                  "properties": { 
                    "id":"Point_"+i,
                    "color":'#00bd01',
                    "radius":8,
                  }, 
                  "geometry": { 
                    "type": "Point", 
                    "coordinates": coordinates 
                  }
                })
              }
            });
            if(coordsError){
              return this.toastMsgFunc('WKT MULTIPOINT格式有误!');
            }
        }
        if(stringType == 'mkt' && this.inputResult.trim().toUpperCase().indexOf('MULTILINESTRING') != -1 && this.inputResult.trim().toLowerCase().indexOf('feature') == -1){
            let lnglatstrlines = this.inputResult.trim().toUpperCase();
            lnglatstrlines = lnglatstrlines.substring(lnglatstrlines.indexOf('((')+2,lnglatstrlines.lastIndexOf('))'));
            lnglatstrlines = lnglatstrlines.replace(/\)\,\(/g,';');
            coordsError = false;
            lnglatstrlines.split(';').forEach((v,i)=>{
              v.split(',').forEach(m=>{
                if(!/^[+-]?\d{1,3}(\.\d+)?\ \s*[+-]?\d{1,2}(\.\d+)?$/.test(m)){
                  coordsError = true;
                }
              })
              if(!coordsError){
                let coordinates = v.split(',').map(m=>{return m.split(' ').map(q=>{return parseFloat(q)})})
                coordinates.forEach(m=>{
                  bounds.push(m);
                })
                if(coordinates.length >= 3 && this.wayPointSitch){
                      //途径点的坐标
                      coordinates.forEach((m,n)=>{
                      if(n>0 && n<coordinates.length-1){
                        geojson.features.push({
                            "type": "Feature", 
                            "properties": { 
                              "id":"wayPoint_"+n,
                              "color":'#409EFF',
                              "radius":8,
                            }, 
                            "geometry": { 
                              "type": "Point", 
                              "coordinates": m 
                            }
                        })
                      }
                    })
                }
                geojson.features.push({
                    "type": "Feature", 
                    "properties": { 
                      "id":"LineString_"+i,
                      "color": '#00bd01',
                      "width": 5
                    }, 
                    "geometry": { 
                      "type": "LineString", 
                      "coordinates": coordinates
                    } 
                  })
              }
            });
            if(coordsError){
              return this.toastMsgFunc('WKT MULTILINESTRING格式有误!');
            }
        }
        if(stringType == 'mkt' && this.inputResult.trim().toUpperCase().indexOf('MULTIPOLYGON') != -1 && this.inputResult.trim().toLowerCase().indexOf('feature') == -1){
            let lnglatstrpolygons = this.inputResult.trim().toUpperCase();
            lnglatstrpolygons = lnglatstrpolygons.substring(lnglatstrpolygons.indexOf('MULTIPOLYGON(')+13,lnglatstrpolygons.lastIndexOf(')'));
            lnglatstrpolygons = getPolygon(lnglatstrpolygons);
            coordsError = false;
            lnglatstrpolygons.split(';').forEach((v,i)=>{
              v.split(',').forEach(m=>{
                if(!/^[+-]?\d{1,3}(\.\d+)?\ \s*[+-]?\d{1,2}(\.\d+)?$/.test(m)){
                  coordsError = true;
                }
              })
              if(!coordsError){
                let coordinates = v.split(',').map(m=>{return m.split(' ').map(q=>{return parseFloat(q)})})
                coordinates.forEach(m=>{
                  bounds.push(m);
                })
                if(coordinates.length >= 3 && this.wayPointSitch){
                      //途径点的坐标
                      coordinates.forEach((m,n)=>{
                      if(n>=0 && n<coordinates.length-1){
                        geojson.features.push({
                            "type": "Feature", 
                            "properties": { 
                              "id":"wayPoint_"+n,
                              "color":'#409EFF',
                              "radius":8,
                            }, 
                            "geometry": { 
                              "type": "Point", 
                              "coordinates": m 
                            }
                        })
                      }
                    })
                }
                geojson.features.push({
                  "type": "Feature", 
                  "properties": { 
                    "id":"Polygon_muilt_"+i,
                    "color": '#00bd01',
                    "opacity":0.2
                  }, 
                  "geometry": { 
                    "type": "Polygon", 
                    "coordinates": [coordinates]
                  } 
                })
              }
            });
            if(coordsError){
              return this.toastMsgFunc('WKT MULTILINESTRING格式有误!');
            }
        }
        //geojson
        if(stringType == 'geojson'){
          let inputstring = this.inputResult.trim();
          if(inputstring.lastIndexOf(';') == inputstring.length-1){
            inputstring = inputstring.substring(0,inputstring.length-1)
          }
          inputstring = eval('('+inputstring+')');
          let features = inputstring.features;
          try {
              features.forEach((v,i)=>{
                if(v.geometry.type.toLowerCase() == 'linestring'){
                  geojson.features.push({
                    "type": "Feature", 
                    "properties": { 
                      "id":"LineString_"+i,
                      "color":v.properties?.color || '#00bd01',
                      "width":v.properties?.width || 5,
                    }, 
                    "geometry": { 
                      "type": "LineString", 
                      "coordinates": v.geometry?.coordinates
                    } 
                  })
                  v.geometry.coordinates.forEach((m,n)=>{
                    bounds.push(m)
                    if(n>0 && n<v.geometry.coordinates.length-1 && this.wayPointSitch){
                        geojson.features.push({
                            "type": "Feature", 
                            "properties": { 
                              "id":"wayPoint_"+n,
                              "color":'#409EFF',
                              "radius":8,
                            }, 
                            "geometry": { 
                              "type": "Point", 
                              "coordinates": m 
                            }
                        })
                    }
                  })
                }else if(v.geometry.type.toLowerCase()  == 'point'){
                  geojson.features.push({
                    "type": "Feature", 
                    "properties": { 
                      "id":"Point_"+i,
                      "color":v.properties?.color || '#00bd01',
                      "radius":v.properties?.radius || 8,
                    }, 
                    "geometry": { 
                      "type": "Point", 
                      "coordinates": v.geometry?.coordinates 
                    } 
                  })
                  bounds.push(v.geometry.coordinates);
                }else if(v.geometry.type.toLowerCase() == 'polygon'){
                  geojson.features.push({
                    "type": "Feature", 
                    "properties": { 
                      "id":"Polygon_"+i,
                      "color":v.properties?.color || '#00bd01',
                      "opacity":v.properties?.opacity || 0.2
                    }, 
                    "geometry": { 
                      "type": "Polygon", 
                      "coordinates": v.geometry.coordinates 
                    } 
                  })
                  v.geometry.coordinates[0].forEach((m,n)=>{
                    bounds.push(m);
                    if(n>=0 && n<v.geometry.coordinates[0].length-1 && this.wayPointSitch){
                        geojson.features.push({
                            "type": "Feature", 
                            "properties": { 
                              "id":"wayPoint_"+n,
                              "color":'#409EFF',
                              "radius":8,
                            }, 
                            "geometry": { 
                              "type": "Point", 
                              "coordinates": m 
                            }
                        })
                    }
                  })
                }else if(v.geometry.type.toLowerCase() == 'multipolygon'){
                  v.geometry.coordinates.forEach((polgoncoords,index)=>{
                    geojson.features.push({
                      "type": "Feature", 
                      "properties": { 
                        "id":"Polygon_muilt_"+i+'_'+index,
                        "color":v.properties?.color || '#00bd01',
                        "opacity":v.properties?.opacity || 0.2
                      }, 
                      "geometry": { 
                        "type": "Polygon", 
                        "coordinates": polgoncoords
                      } 
                    })
                    polgoncoords[0].forEach((m,n)=>{
                      bounds.push(m);
                      if(n>=0 && n<polgoncoords[0].length-1 && this.wayPointSitch){
                          geojson.features.push({
                              "type": "Feature", 
                              "properties": { 
                                "id":"wayPoint_"+n,
                                "color":'#409EFF',
                                "radius":8,
                              }, 
                              "geometry": { 
                                "type": "Point", 
                                "coordinates": m 
                              }
                          })
                      }
                    })
                  })
                }else if(v.geometry.type.toLowerCase() == 'multilinestring'){
                  v.geometry.coordinates.forEach((polgoncoords,index)=>{
                    geojson.features.push({
                      "type": "Feature", 
                      "properties": { 
                        "id":"LineString_muilt_"+i+'_'+index,
                        "color":v.properties?.color || '#00bd01',
                        "width":v.properties?.width || 5,
                      }, 
                      "geometry": { 
                        "type": "LineString", 
                        "coordinates": polgoncoords
                      } 
                    })
                    polgoncoords.forEach((m,n)=>{
                      bounds.push(m);
                      if(n>0 && n<polgoncoords.length-1 && this.wayPointSitch){
                          geojson.features.push({
                              "type": "Feature", 
                              "properties": { 
                                "id":"wayPoint_"+n,
                                "color":'#409EFF',
                                "radius":8,
                              }, 
                              "geometry": { 
                                "type": "Point", 
                                "coordinates": m 
                              }
                          })
                      }
                    })
                  })
                }
              });
          } catch (e) {
              return this.toastMsgFunc('GEOJSON格式有误，请检查!');
          }
        }

        if(geojson.features.length == 0){
          return;
        }
        
        if(judgeIE()){
          let layers = [];
          bounds = [];
          geojson.features.forEach(v=>{
            let layer = null;
            let coord = JSON.parse(JSON.stringify(v.geometry.coordinates))
            if(v.geometry.type == 'Point'){
              layer = new nimap.CircleMarker({
                  center: v.geometry.coordinates.join(','),
                  radius:v.properties.radius,
                  'fill-color': v.properties.color,
                  'fill-outline-color': v.properties.color,
              });
              bounds.push(coord);
            }else if(v.geometry.type == 'LineString'){
                layer = new nimap.Polyline({
                    path: v.geometry.coordinates, 
                    "line-width":v.properties.width,
                    'line-color':v.properties.color,
                });
                if(Object.prototype.toString.call(coord[0]) == '[object Array]' && Object.prototype.toString.call(coord[0][0]) != '[object Array]' ){
                  bounds = bounds.concat(coord);
                }else if(Object.prototype.toString.call(coord[0]) == '[object Array]' && Object.prototype.toString.call(coord[0][0]) == '[object Array]' && Object.prototype.toString.call(coord[0][0][0]) != '[object Array]' ){
                  bounds = bounds.concat(coord[0]);
                  coord.forEach(q=>{
                    bounds = bounds.concat(q);
                  });
                }
            }else if(v.geometry.type == 'Polygon'){
                layer = new nimap.Polygon({
                      path: v.geometry.coordinates,//设置多边形边界路径
                      'fill-color': v.properties.color,
                      'fill-outline-color': v.properties.color,
                      'fill-opacity': v.properties.opacity,
                });
                if(Object.prototype.toString.call(coord[0]) == '[object Array]' && Object.prototype.toString.call(coord[0][0]) != '[object Array]' ){
                  bounds = bounds.concat(coord);
                }else if(Object.prototype.toString.call(coord[0]) == '[object Array]' && Object.prototype.toString.call(coord[0][0]) == '[object Array]' && Object.prototype.toString.call(coord[0][0][0]) != '[object Array]' ){
                  bounds = bounds.concat(coord[0]);
                  coord.forEach(q=>{
                    bounds = bounds.concat(q);
                  });
                }
            }
            layers.push(layer);
          })
          if(ieOverlayGroup){
            ieOverlayGroup.clearOverlays();
          }
          ieOverlayGroup = new nimap.OverlayGroup(layers);
          ieOverlayGroup.addTo(globalMap);
          globalMap.setFitView(bounds);
        }else{
          globalMap.addSource('geojsondata',{
            type: 'geojson',
            data: geojson
          });
          globalMap.addLayer({id:'geojson_line',type: 'line',source: 'geojsondata',layout:{'line-cap':'round','line-join':'round'},paint: {'line-color': ['get','color'], 'line-width': ['get','width']},filter: ['in', '$type', 'LineString']});
          globalMap.addLayer({id:'geojson_polygon',type: 'fill',source: 'geojsondata',layout:{},paint: {'fill-color': ['get','color'], 'fill-opacity': ['get','opacity']},filter: ['in', '$type', 'Polygon']});
          globalMap.addLayer({id:'geojson_point',type: 'circle',source: 'geojsondata',layout:{},paint: {'circle-color': ['get','color'], 'circle-radius': ['get','radius']},filter: ['in', '$type', 'Point']});
          bounds = bounds.map(v=>{return v.join(',')}).join(';')
          setFitView(bounds);
        }
        
      }
      
      
  }
}

</script>
<style>
.app{width:100%;height:100%}
.mapWrap{border:4px solid #5553df;position: absolute;top:90px;bottom:30px;left: 500px;right:10px;display: inline-block;}
.bar{width: 400px;position: absolute;top:90px;bottom:30px;left:30px;display: inline-block;}
#option-panel{ position: absolute; right: 40px; top: 110px; }
#option-panel{ height: 24px; padding: 4px; box-sizing: content-box;  background-color: #fff; }
#option-panel .city-selector, #option-panel .traffic,#option-panel .tool-box{ display: inline-block; }
#option-panel .city-name{ display: inline-block; height: 24px; padding: 0 10px 0 10px; line-height: 24px; color: #333; }
#option-panel .city-panel-box,
#option-panel .traffic-panel,
#option-panel .tool-panel{ position: absolute; right: 0; top: 36px; }
/**勿删，集成在lbs平台中 */
.top-nav, .top-nav:hover {
    background-color: #2e3037;
}
</style>


